<template lang="pug">
shListData(title="Etiquetas" resolver="labels" keyData="label" component="shLabel")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Labels',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/label/Labels.vue